import React from 'react';

import classes from './Logo.css';
import spectrum from './Spectrum-logo-253x69.png';

const logo = (props) => (
  <div className={classes.Logo} style={{ height: props.height }}>
  <img src={spectrum} alt={'Spectrum'}/>
  <span>WI<span>N</span></span>
  </div>
);

export default logo;
